import styled from 'styled-components';

export const OptionBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  margin-bottom: 16px;
  position: relative;

  label {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.gray0};
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 19px -5px 0 -5px;
`;

export const AddImage = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  font-size: 32px;
  border: 2px dashed ${({ theme }) => theme.colors.primaryGreen500};

  flex: 1;
  border-radius: 4px;
  padding: 26px 0;
  margin: 5px;
  min-width: 20%;

  :before {
    background: -webkit-linear-gradient(rgba(64, 255, 175, 1), rgba(0, 184, 107, 1));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const ImageWrapper = styled.div`
  width: 25vw;
  height: 25vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 13px;

  img {
    width: 25vw;
    height: 25vw;
    border-radius: 13px;
    padding: 5px;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  left: 9px;
  top: 9px;
  width: 24px;
  height: 24px;
  padding: 4px;
  background: rgba(28, 38, 49, 0.56);
  border-radius: 4px;
  border: none;
  font-size: 16px;
`;
